export default __webpack_public_path__ + "static/media/advancly-logo.f289e284.png";